const equals = (arr1, arr2) => {
  const type = Object.prototype.toString.call(arr1);

  if (type !== Object.prototype.toString.call(arr2)) return false;

  if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;

  const arr1Len = type === '[object Array]' ? arr1.length : Object.keys(arr1).length;
  const arr2Len = type === '[object Array]' ? arr1.length : Object.keys(arr2).length;
  if (arr1Len !== arr2Len) return false;

  // Compare two items
  const valueArr1 = JSON.stringify(arr1);
  const valueArr2 = JSON.stringify(arr2);

  return valueArr1 === valueArr2;
};

export default equals;



// WEBPACK FOOTER //
// ./src/helpers/equals.js